import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteScrollReset = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    root.style.scrollBehavior = previous;
  }, [pathname]);

  return null;
};

export default RouteScrollReset;
